<template>
    <div class="AddRelationship">
        <el-form :model="params" :rules="rules" ref="params" >
            <el-form-item label="开始节点：" prop="startNodeName">
                <el-autocomplete 
                v-model="params.startNodeName" 
                placeholder="请输入开始节点" 
                clearable 
                :fetch-suggestions="querySearch"
                :trigger-on-focus="false"
                @select="handlestartSelect"
                style="width: 280px;">
                    <template slot-scope="{ item }">
                        <div>{{ item.nodeName}}</div>
                    </template>
            </el-autocomplete>
            </el-form-item>
            <el-form-item label="结束节点：" prop="endNodeName">
                <el-autocomplete 
                class="inline-input"
                v-model="params.endNodeName"  
                placeholder="请输入结束节点" 
                clearable
                :fetch-suggestions="querySearch"
                :trigger-on-focus="false"
                @select="handleendSelect"
                style="width: 280px;">
                <template slot-scope="{ item }">
                    <div>{{ item.nodeName}}</div>
                </template>
            </el-autocomplete>
            </el-form-item>
            <el-form-item label="关系名称：" prop="relationshipName">
                <el-input v-model="params.relationshipName" placeholder="请输入关系名称" clearable style="width: 280px;"></el-input>
            </el-form-item>
            <el-form-item label="关系类型：" prop="relationshipType">
                <el-autocomplete 
                v-model="params.relationshipType" 
                placeholder="请输入关系类型" 
                clearable
                :fetch-suggestions="querySearchtype"
                :trigger-on-focus="true"
                @select="handletypeSelect"
                style="width: 280px;">
                <template slot-scope="{ item }">
                    <div>{{ item}}</div>
                </template>
            </el-autocomplete>
            </el-form-item>
            <el-form-item label="关系描述：" prop="relationshipDescription">
                <el-input v-model="params.relationshipDescription" type="textarea" placeholder="请输入关系描述" clearable style="width: 280px;"></el-input>
            </el-form-item>
            <el-form-item label="其他属性：">
                <div style="display: inline-block;">
                    <el-row :span="24" v-for="(item,index) in params.otherAttr" :key="index" style="margin-bottom: 10px;">
                        <el-col :span="6"><el-input v-model="item.attrName" placeholder="请输入属性名"></el-input></el-col>
                        <el-col :span="12" style="margin-left: 20px;"><el-input v-model="item.attrValue" placeholder="请输入属性值"></el-input></el-col>
                        <el-col :span="2" style="margin-left: 20px;" v-if="index==params.otherAttr.length-1"><el-button type="primary" @click="ADDattribute">新增</el-button></el-col>
                        <el-col :span="2" style="margin-left: 20px;" v-else><el-button type="primary" @click="Delete(index)">删除</el-button></el-col>
                    </el-row>
                </div>
            </el-form-item>
        </el-form>
        <div style="text-align: center;">
            <el-button type="primary" @click="submitForm('params')">{{$route.query.type?'修改':'提交'}}</el-button>
            <el-button @click="$router.go(-1)">取消</el-button>
        </div>
    </div>
</template>
<script>
export default{
    name:'AddRelationship',
    data() {
        return {
            AllRelationshipType:[],
            iscopy:this.$route.query.iscopy,
            rules:{
                startNodeName:[{ required: true, message: '请输入开始节点', trigger: 'blur' }],
                endNodeName:[{ required: true, message: '请输入结束节点', trigger: 'blur' }],
                relationshipName:[{ required: true, message: '请输入关系名', trigger: 'blur'}],
                relationshipType:[{ required: true, message: '请输入关系类型', trigger:['blur','change'] }],
                relationshipDescription:[{ required: true, message: '请输入关系描述', trigger: 'blur' }],
            },
            params:{
                startNodeName:'',
                source:'',
                startNodeType:'',
                target:'',
                endNodeType:'',
                endNodeName:'',
                relationshipType:'',
                relationshipName:'',
                relationshipDescription:'',
                otherAttr:[{attrName:'',attrValue:''}]
            }
        }
    },
    created() {
        this.getAllRelationshipType();
        if(this.$route.query.type){
            this.getRelationshipByTypeAndId(this.$route.query);
        }
    },
    methods: {
        // 获取详情
        getRelationshipByTypeAndId(val){
            this.$Http_Post('relationship/getRelationshipByTypeAndId',{id:val.id,type:val.type,model:'industry'}).then(res=>{
                if(res.Code==0){
                    this.params=res.Data;
                    this.params.startNodeName=res.Data.startNode.nodeName;
                    this.params.endNodeName=res.Data.endNode.nodeName;
                }else{
                    this.$message({type: 'error', message:res.Message});
                }
            });
        },
        // 获取所有关系类型
        getAllRelationshipType(){
            this.$Http_Post('relationship/getAllRelationshipType',{model:'industry'}).then(res=>{
                if(res.Code==0){
                    this.AllRelationshipType=res.Data;
                }else{
                    this.$message({type: 'error', message:res.Message});
                }
            })
        },

        querySearch(queryString, cb) {
            var restaurants='';
                this.$Http_Post('node/getNodeListByNodeName',{nodeName:queryString,model:'industry',pageNum:1,pageSize:10}).then(res=>{
                    if(res.Code==0){
                        restaurants=res.Data;
                        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                        // 调用 callback 返回建议列表的数据
                        setTimeout(function(){
                            cb(results);
                        },500);
                    }else{
                        this.$message({type: 'error', message:res.Message});
                    }
                })
        },
        createFilter(queryString) {
            return (restaurant) => {
                return (restaurant.nodeName.includes(queryString));
            };
        },
        handlestartSelect(item){
            this.params.startNodeType=item.type;
            this.params.source=item.id;
            this.params.startNodeName=item.nodeName;
        },
        handleendSelect(item){
            this.params.target=item.id;
            this.params.endNodeType=item.type;
            this.params.endNodeName=item.nodeName;
        },
        querySearchtype(queryString, cb){
            var restaurants=this.AllRelationshipType;
            var results = queryString ? restaurants.filter(this.createtypeFilter(queryString)) : restaurants;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        createtypeFilter(queryString) {
            return (restaurant) => {
                return (restaurant.includes(queryString));
            };
        },
        handletypeSelect(item){
            this.params.relationshipType=item;
        },

        submitForm(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.params['model']='industry';
                    let URL=this.iscopy==0?'relationship/editRelationship':'relationship/createRelationship';
                    this.$Http_Post(URL,this.params).then(res=>{
                        if(res.Code==0){
                            this.$message({type: 'success', message:res.Message});
                        }else{
                            this.$message({type: 'error', message:res.Message});
                        }
                    })
                }
            })
        },
        ADDattribute(){
            if(this.params.otherAttr[this.params.otherAttr.length-1].attrName=='' || this.params.otherAttr[this.params.otherAttr.length-1].attrValue==''){
                this.$message({type: 'error', message:"请先填写完整属性内容"});
                return false
            }
            this.params.otherAttr.push({attrName:'',attrValue:''})
        },
        Delete(index){
            this.params.otherAttr.splice(index,1);
        }
    },
}
</script>
<style scoped>
.AddRelationship{background: #fff;padding: 20px;}
.AddRelationship .avatar-uploader .el-upload {border: 1px dashed #d9d9d9;border-radius: 6px; cursor: pointer;position: relative; overflow: hidden;}
.avatar {width: 178px;height: 178px;display:inline-block;}
</style>